<template>
  <div>
    <div v-if="className == 'mk-subject-tabs'" class="mk-subject-tabs">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="mk-subject-tabs-top">
        <div
          :class="index == 0 ? 'tab-active' : ''"
          v-for="(item, index) in childItem.propsValue.data.slice(0, 4)"
          :key="index"
        >{{ item.customField1 }}</div>
      </div>
      <div class="mk-subject-tabs-bottom">
        <div class="swiper mk-subject-tabs-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in childItem.propsValue.data.slice(0, 1)"
              :key="index"
            >
              <div class="tab-top">
                <div class="tab-title">{{ item.customField1 }}</div>
                <div class="tab-jump">{{ item.customField4.text }}</div>
              </div>
              <div class="tab-summary">{{ item.customField2 }}</div>
              <div class="tab-bottom">
                <img :src="item.customField3.contentImage | imgUrl" alt />
                <img
                  v-if="item.customField3.contentType == 'video'"
                  class="video-block-play"
                  src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="className == 'mk-subject-data'" class="mk-subject-data">
      <div class="mk-subject-title">{{ element.titleBarName }}</div>
      <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
      <div class="mk-subject-data-list">
        <div class="swiper mk-subject-data-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in childItem.propsValue.data.slice(0, 1)"
              :key="index"
            >
              <div class="mk-subject-data-img">
                <img :src="item.customField3.contentImage | imgUrl" alt />
                <img
                  v-if="item.customField3.contentType == 'video'"
                  class="video-block-play"
                  src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
                />
              </div>
              <div class="mk-subject-data-title">
                <div class="data-title">{{ item.customField1 }}</div>
                <div class="data-jump">{{ item.customField4.text }}</div>
              </div>
              <div class="mk-subject-data-summary">{{ item.customField2 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createUUID } from "../../../../../utils/methods";
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  buttonObject,
  contentObject
} from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp = _.cloneDeep(buttonObject);
buttonObjectTemp.text = "进一步了解 >";
export default {
  name: "MkContentGroupPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      projectData: state => state.autowebStore.projectData
    }),
    className() {
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      return selectClass.value;
    }
  },

  mounted() {
    // 第一版本对象属性跟第二版本不一样，升级组件属性
    if (
      this.element &&
      this.element.childNode &&
      this.element.childNode.length > 0
    ) {
      this.updatePropsValue();
    }
  },
  methods: {
    ...mapMutations(["setProjectData"]),
    // 升级组件属性方法
    updatePropsValue() {
      console.log(111);
      let updateFlag = false;
      this.projectData.elements = _.map(this.projectData.elements, el => {
        // 找到落地页当前组件
        if (el.uuid == this.element.uuid) {
          updateFlag = true;
          el.childNode = _.map(el.childNode, child => {
            let uuids = [];
            child.propsValue.data = child.propsValue.data.map(data => {
              if (
                data.hasOwnProperty("customField4") &&
                uuids.indexOf(data.customField4.uuid) > -1
              ) {
                data.customField4.uuid = createUUID();
              } else {
                uuids.push(data.customField4.uuid);
              }
              return data;
            });
            return child;
          });
          return el;
        } else {
          return el;
        }
      });
      updateFlag ? this.setProjectData(this.projectData) : "";
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "素材",
          type: "content",
          contentType: "image,video",
          defaultType: "image",
          width: 375,
          height: 340,
          isMultiple: false
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        }
      ],
      data: [
        {
          customField1: "财务共享",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1: "智慧税务",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1: "全球司库",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1: "电子会计档案",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1: "全球司库",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        },
        {
          customField1: "电子会计档案",
          customField2:
            "账表协同，提升财报速度，事项中台，提升管理精度，建议 全栈国产，满足大型企业信创要求。",
          customField3: _.cloneDeep(contentObject),
          customField4: _.cloneDeep(buttonObjectTemp)
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-tabs {
  padding: 0.56rem 0.42rem 0.42rem;
  background-color: #fff;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.56rem;
  }
  .mk-subject-tabs-top {
    width: 100%;
    display: flex;
    overflow-x: auto;
    justify-content: space-between;
    border-bottom: 1px solid #717071;
    div {
      /* 不换行 */
      white-space: nowrap;
      height: 0.37rem;
      font-size: 0.22rem;
      margin-right: 0.5rem;
      padding-bottom: 0.15rem;
    }
    .tab-active {
      border-bottom: 0.03rem solid #e60012;
    }
  }
  .mk-subject-tabs-top::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  .mk-subject-tabs-bottom {
    padding-top: 0.4rem;
    width: 100%;
    overflow: hidden;
  }
  .tab-top {
    display: flex;
    justify-content: space-between;
    padding-left: 0.15rem;
    margin-bottom: 0.27rem;
    .tab-title {
      font-family: AlibabaPuHuiTi_3_65_Medium;
      font-size: 0.28rem;
      color: #515051;
      line-height: 0.42rem;
    }
    .tab-jump {
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 0.22rem;
      color: #7664c8;
      line-height: 0.42rem;
      text-transform: none;
    }
  }
  .tab-summary {
    padding-left: 0.5rem;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.39rem;
    text-transform: none;
    text-align: left;
    margin-bottom: 0.38rem;
  }
  .tab-bottom {
    padding-left: 0.5rem;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .video-block-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }
}
.mk-subject-data {
  padding: 0.56rem 0 0.42rem 0.42rem;
  background-color: #fff;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.56rem;
  }
  .mk-subject-data-swiper .swiper-slide {
    margin-right: 0.56rem;
  }
  .mk-subject-data-img {
    height: auto;
    display: flex;
    margin-bottom: 0.42rem;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .video-block-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }
  .mk-subject-data-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.27rem;
    .data-title {
      font-family: AlibabaPuHuiTi_3_65_Medium;
      font-size: 0.28rem;
      color: #515051;
      line-height: 0.42rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0.1rem;
    }
    .data-jump {
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 0.22rem;
      color: #7664c8;
      line-height: 0.42rem;
      text-transform: none;
    }
  }
  .mk-subject-data-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.35rem;
    text-align: left;
  }
}
</style>